import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy } from '@angular/core';

import { select, Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as StrategyActions from '@strategy/strategy.actions';
import * as fromStrategy from '@strategy/reducers';

import { Notification } from '@shared/models/Strategy';
import { TrackingService } from '@shared/services/tracking.service';

@Component({
  selector: 'app-strategy-notification',
  templateUrl: './strategy-notification.component.html',
  styleUrls: ['./strategy-notification.component.scss'],
  standalone: false
})
export class StrategyNotificationComponent implements OnDestroy {
  protected readonly onDestroy$ = new Subject<void>();
  actionTranslationKey: string;
  notification: Notification;

  constructor(
    public http: HttpClient,
    private store: Store,
    private trackingService: TrackingService
  ) {
    this.store.pipe(select(fromStrategy.selectNotificationData), takeUntil(this.onDestroy$)).subscribe((notification) => {
      this.notification = notification;

      if (!notification.show) {
        return;
      }

      switch (notification.type) {
        case 'addWish':
          this.actionTranslationKey = 'new_strategy.notifications.add_wishlist';
          break;
        case 'clearWish':
          this.actionTranslationKey = 'new_strategy.notifications.remove_wishlist';
          break;
        case 'addBlocked':
          this.actionTranslationKey = 'new_strategy.notifications.add_blacklist';
          break;
        case 'clearBlocked':
          this.actionTranslationKey = 'new_strategy.notifications.remove_blacklist';
          break;
        default:
          break;
      }
    });
  }

  undoChanges(): void {
    this.trackingService.trackActivity('[Button] Undo');
    this.store.dispatch(StrategyActions.undoStrategyActions());
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
